<template>
    <div id="price-guide">
        <div class="price-guide-wrapper" v-if="layouts.length" >
            <div class="price-guider-currency-select">
                <a class="gbp" v-on:click.prevent="selectCurrency('gbp')" :class="{'active' : currency=='gbp'}">£</a>
                <a class="eur" v-on:click.prevent="selectCurrency('eur')" :class="{'active' : currency=='eur'}">€</a>
            </div>
            <div class="price-guide-selector">
                <h4>Number of Guests:</h4>
                <vue-slider ref="slider" v-model="selection" v-bind="sliderOptions"></vue-slider>
            </div>

            <div class="price-guide-title" v-if="layouts.length">
                <h6>Estimated Price:</h6>
                <h3>{{ total(currency)|currency(currency) }}</h3>
                <h6>Not Including VAT or Delivery</h6>
            </div>

            <div class="price-guide-site-plan" v-if="layouts.length && selected" :style="{backgroundImage:'url('+selected.sitePlan+')'}" >
                <img :src="selected.sitePlan" :alt="selected.detailsTitle">

                <div class="price-guide-extras-toggle" :class="{active:accessoriesVisible}" v-on:click.prevent="accessoriesVisible = !accessoriesVisible">
                    <span v-if="accessoriesVisible"><i class="fa fa-minus"></i>Close Extras</span>
                    <span v-if="!accessoriesVisible"><i class="fa fa-plus"></i>Add Extras</span>
                </div>

                <div class="price-guide-overlay" :class="{ 'price-guide-overlay--closed' : hideOverlay }">
                    <button class="price-guide-overlay-toggle" @click="hideOverlay = !hideOverlay">
                        <svg v-if="!hideOverlay" viewBox="0 0 20 20" fill="currentColor" class="arrow-narrow-right w-6 h-6"><path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        <svg v-if="hideOverlay" viewBox="0 0 20 20" fill="currentColor" class="arrow-narrow-left w-6 h-6"><path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd"></path></svg>
                    </button>
                    <div class="price-guide-overlay__title">
                        <h3>{{selected.layoutTitle}}</h3>
                    </div>
                    <vue-perfect-scrollbar class="price-guide-overlay__inner" :settings="scrollbarOptions">
                        <div class="price-detail-category" v-if="activeAccessories.length">
                            <div class="price-detail-category__title"><h4>Extras <span class="remove" v-on:click="removeExtras()">Remove Extras</span></h4></div>
                            <div class="price-detail" v-for="detail in activeAccessories">
                                <span class="price-detail__label">{{detail.name}}</span>
                                <span class="price-detail__price">

                                                            <span>{{detail[currency]|currency(currency)}}</span>
                                                        </span>
                            </div>
                        </div>

                        <div v-for="details in selected.details" class="price-detail-category">
                            <div >
                                <h4>{{details.detailsTitle}}</h4>
                            </div>
                            <div class="price-detail"v-for="detail in details.details">
                                <span class="price-detail__label">{{detail.name}}</span>
                                <span class="price-detail__price">
                                                        <span v-if="detail.gbp">{{detail[currency]|currency(currency)}}</span>
                                                    </span>
                            </div>
                        </div>
                        <div class="price-detail-add">
                            <a href="#accessories" v-on:click.prevent="accessoriesVisible = true" class="link">Add Extras</a>
                        </div>

                    </vue-perfect-scrollbar>
                    <div class="price-guide-overlay__contact" v-on:click="bookingVisible=true">
                        <span>Book Now!</span>
                    </div>
                </div>

                <div class="price-guide-accessories" v-if="accessoriesVisible">
                    <vue-perfect-scrollbar class="price-guide-accessories__inner" :settings="scrollbarOptions">
                        <div class="accessories">
                            <div class="accessory" v-for="accessory in accessories" v-on:click="accessory.active = !accessory.active" :class="{active: accessory.active}">
                                <div class="accessory__image">
                                    <div class="acceessory__caption">
                                        <i class="fa fa-plus" v-if="!accessory.active"></i>
                                        <i class="fa fa-minus-circle" v-if="accessory.active"></i>
                                    </div>
                                    <img :src="accessory.image" alt="Accessory">
                                </div>
                                <div class="accessory__description">
                                    <h5>{{accessory.name}}</h5>
                                    <span class="price">
                                                            <span>{{accessory[currency]|currency(currency)}}</span>
                                                        </span>
                                </div>
                            </div>
                        </div>
                    </vue-perfect-scrollbar>
                </div>
            </div>

        </div>

        <div class="price-guide-contact-wrapper" v-if="bookingVisible" v-on:click="bookingVisible = false">
            <div class="price-guide-contact" v-on:click.stop>


                <button class="price-guide-contact__close-button" v-on:click.prevent="bookingVisible=false"><i class="fa fa-close"></i></button>
                <div class="price-guide-contact__title text-center">
                    <h3>Contact us to book</h3>
                    <p>Send us your configuration and a member of our team will be in touch to guide you through the rest of the process</p>
                </div>

                <div v-if="loading" class="contact-form__wrapper">
                <div class="contact-form__loader" ></div>
                </div>
                <div class="contact-form__success" ref="success" v-show="success">
                    Thank you for your enquiry, a member of our team will be in touch as soon as possible.
                </div>

                <div class="contact-form__errors" ref="error" v-show="errors">
                    We have detected some errors with your submission
                    <ul>
                        <li v-for="error in errors">
                            <span v-for="message in error">{{message}}</span>
                        </li>
                    </ul>
                </div>


                <form method="post" action="" accept-charset="UTF-8" v-on:submit.prevent="sendForm">
                    <input type="hidden" name="action" value="contact-form/send">

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="from-name">Your Name</label>
                                <input id="from-name" class="form-control" type="text" name="fromName">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="from-email">Your Email</label>
                                <input id="from-email" class="form-control" type="text" name="fromEmail" >
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="preferred-date">Preferred Date of Wedding</label>
                                <input id="preferred-date" class="form-control" type="text" name="message[Preferred Date Of Wedding]" >
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="guests">Number of Guests</label>
                                <input id="guests" class="form-control" type="text" name="message[Exact Number of Guests]" >
                            </div>
                        </div>
                    </div>


                    <input type="hidden" value="Price Guide Submission" class="hidden" name="subject">
                    <input type="hidden" :value="total(currency)" class="hidden" name="message[Total Price]">
                    <input type="hidden" :value="currency" class="hidden" name="message[Currency]">
                    <input type="hidden" :value="selected.capacity" class="hidden" name="message[Selected Number of Guests]">
                    <input type="hidden" v-for="detail in activeAccessories" :value="detail.name" class="hidden" :name="'message[Extra - ' + detail.name + ']'" >

                    <input type="submit" value="Send" class="btn btn-outline-primary btn-lg btn-block">
                </form>

            </div>
        </div>

    </div>
</template>

<script>
    import vueSlider from 'vue-slider-component';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import Datepicker from 'vuejs-datepicker';
    import qs from 'qs'

    export default {
        components: {
            vueSlider,
            VuePerfectScrollbar,
            Datepicker
        },
        data() {
            return {
                errors: null,
                success: false,
                loading: false,
                layouts: [],
                accessories: [],
                currency: 'gbp',
                accessoriesVisible: false,
                selection: 0,
                bookingVisible: false,
                sliderOptions: {
                    piecewiseLabel: true,
                    tooltipDir: "bottom",
                    height: 20,
                    dotSize: 30
                },
                scrollbarOptions: {
                    maxScrollbarLength: 60,
                    suppressScrollX: true,
                    wheelPropagation: true
                },
                hideOverlay: false
            }
        },
        mounted() {
            this.getLayouts();
            this.getAccessories();

        },
        methods: {
            getLayouts() {
                const self = this;
                axios.get('/api/tipi-layouts.json').then((data)=> {
                    self.layouts = data.data.data[0].layouts;
                    self.activeLayout = self.layouts[0]
                    self.selection = this.layouts[0].capacity
                    this.initSlider();
                });
            },
            getAccessories() {
                const self = this;
                axios.get('/api/tipi-accessories.json').then((data)=> {
                    self.accessories = data.data.data[0].accessories;

                    self.accessories.forEach(item => {
                        Vue.set(item, 'active', false);
                    });
                });
            },
            initSlider() {
                let data = this.layouts.map(a => a.capacity);
                this.sliderOptions = Object.assign({}, this.sliderOptions, {
                    min:0,
                    max:this.layouts.length,
                    data: data,
                    tooltip: false,
                    piecewiseLabel: true,
                    piecewise: true
                });

            },
            total(currency) {
                let sum = 0;
                this.selected.details.forEach(details => {
                    details.details.forEach(detail => {
                        sum += parseFloat(detail[currency]);
                    })
                });

                this.activeAccessories.forEach(detail => {
                    sum += parseFloat(detail[currency]);
                });
                return sum;
            },
            selectCurrency(currency) {
                this.currency = currency;
            },
            removeExtras() {
                this.accessories.forEach(item=>{
                    item.active=false;
                })
            },

            sendForm(ev) {
                let form = new FormData(ev.target);

                let data = {};
                data[this.csrfName] = this.csrfToken;
                Array.from(form.entries()).map(entry => {
                    data[entry[0]] = entry[1]
                });
              data['toEmail'] = "tipis@magnakata.com";

                this.loading = true;
                this.errors = null;
                axios.post('/', qs.stringify(data))
                        .then(response => {
                            this.loading = false;
                            if (response.data.errors) {
                                this.errors = response.data.errors;
                            } else {
                                this.success = true;
                            }
                        })
                // let data = {};
                // data['message'] = {
                //
                // }
                //
                // console.log(data);

                // data[this.csrfName] = this.csrfToken;
                // data['action'] = 'contact-form/send'; // Append CSRF Token
                // $.post({
                //     url: '/',
                //     dataType: 'json',
                //     data: data,
                //     success: function(response) {
                //         if (response.success) {
                //             alert('success');
                //         } else {
                //             // response.error will be an object containing any validation errors that occurred, indexed by field name
                //             // e.g. response.error.fromName => ['From Name is required']
                //             alert('An error occurred. Please try again.');
                //         }
                //     }
                // });
            }
        },
        computed: {
            selected() {
                return this.layouts.find(element => {
                    return element.capacity == this.selection
                })
            },
            activeAccessories() {
                return this.accessories.filter(element => {
                    return element.active;
                })
            },
            csrfName () {
                return window.csrfTokenName
            },
            csrfToken () {
                return window.csrfTokenValue
            },
            quote() {
                let str = '';

                str += '<h5>Total Price - '+this.total(this.currency) + ' ('+this.currency+')'+'</h5><br/>';

                return str;

            },
            formData() {
                let message = {};
                if (this.selected) {
                    message["Layout"] = this.selected.layoutTitle;
                    message["Capacity"] = this.selected.capacity;
                }

                let accessories = {}
                if (this.activeAccessories) {
                    this.activeAccessories.map((accessory, index) => {
                        accessories["Accessory " + (index + 1)] = accessory.name;
                    })
                }

                message = {...message, ...accessories};

                return {
                };
            }
        },
        watch: {
            bookingVisible: {
                handler(value) {
                    if (value) {
                        document.body.style.setProperty("overflow", "hidden")
                    } else {
                        document.body.style.removeProperty("overflow")
                    }
                },
                immediate: true
            }
        }
    }
</script>